import { TbEdit } from 'react-icons/tb';
import { DefaultButton } from '../../../components/Button/Button';
import {
  HourInput,
  LabelInput,
  SelectInput,
} from '../../../components/Input/Input';
import { oSStatusOptions } from '../../../screens/ModalBudget/utils/constants';
import { BUDGET_TABS } from '../../../screens/ModalBudget/utils/enum';
import { useConsultants } from './select-with-create-options/useConsultants';
import { useFormOfPayment } from './select-with-create-options/useFormOfPayment';
import { useTypeOs } from './select-with-create-options/useTypeOS';
import './styles.scss';

export const OSDetails = (props) => {
  const {
    budget,
    onChange,
    client,
    clientLoading,
    values,
    setOpen,
    vehicle,
    vehicleLoading,
    company,
    setCurrentClientId,
    setCurrentVehicleId,
    setValues,
    setSetHasCreatedConsultant,
    setReloadPrint,
    reloadPrint,
    setOldValues,
    setHasCreated,
    setHasCreatedTypeOS,
    reloadConsultants,
    reloadTypeOS,
    setConsultantState,
    setClientCreationContext,
  } = props;

  const { InputFormOfPayment } = useFormOfPayment({
    company,
    onChange,
    reloadPrint,
    setHasCreated,
    setOldValues,
    setReloadPrint,
    setValues,
    values,
  });
  const { InputConsultant } = useConsultants({
    company,
    onChange,
    values,
    reloadConsultants,
    setReloadPrint,
    setValues,
    setSetHasCreatedConsultant,
    setConsultantState,
  });
  const { InputTypeOS } = useTypeOs({
    company,
    setReloadPrint,
    setValues,
    onChange,
    setHasCreatedTypeOS,
    values,
    reloadTypeOS,
  });

  if (budget !== BUDGET_TABS.DETAILS) {
    return;
  }

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
      className="budget-details-inputs"
    >
      <div className="budget-modal-main-div">
        <div className="size-dropdown">
          <div className="void-class">
            <SelectInput
              onChange={(event) => onChange('client', event)}
              placeholder={clientLoading ? 'Carregando clientes...' : 'Escolha o Cliente'}
              label={'Cliente'}
              options={client}
              defaultValue={
                client?.find(
                  (item) =>
                    item.value === values?.client?.value ||
                    item.value === values?.client
                ) || null
              }
            />
          </div>
        </div>
        <DefaultButton
          className="action-button"
          label={'+'}
          onClick={() => {
            setOpen(3);
            setCurrentClientId(0);
            setClientCreationContext('client');
          }}
        />

        <DefaultButton
          style={{ backgroundColor: '#6694ec' }}
          className="action-button"
          label={<TbEdit style={{ width: 20, height: 20 }} />}
          onClick={() => {
            setOpen(3);
            setCurrentClientId(
              typeof values.client === 'object'
                ? values.client.value
                : values.client
            );
          }}
        />
      </div>
      <div className="budget-modal-main-div">
        <div className="size-dropdown">
          <div className="void-class">
            <SelectInput
              onChange={(event) => onChange('vehicle', event)}
              placeholder={vehicleLoading ? 'Carregando veículos...' : 'Escolha o Veículo'}
              label={'Veículo'}
              options={vehicle}
              defaultValue={
                vehicle?.find(
                  (item) =>
                    item.value === values?.vehicle?.value ||
                    item.value === values?.vehicle
                ) || null
              }
            />
          </div>
        </div>
        <DefaultButton
          className="action-button"
          label={'+'}
          onClick={() => {
            setOpen(4);
            setCurrentVehicleId(0);
          }}
        />

        <DefaultButton
          style={{ backgroundColor: '#6694ec' }}
          className="action-button"
          label={<TbEdit style={{ width: 20, height: 20 }} />}
          onClick={() => {
            setOpen(4);
            setCurrentVehicleId(
              typeof values.vehicle === 'object'
                ? values.vehicle.value
                : values.vehicle
            );
          }}
        />
      </div>

      <div className="os-details-grid-date-fields">
        <LabelInput
          className="remove-margin"
          type="date"
          value={values?.entry_date}
          onChange={(value) => onChange('entry_date', value)}
          placeholder={'Data entrada'}
          label={'Data entrada'}
        />

        <div>
          <HourInput
            is24HoursLimited
            className="remove-margin"
            label="Hora entrada"
            value={values?.entry_hour}
            onChange={(value) => onChange('entry_hour', value)}
          />
        </div>
      </div>

      <LabelInput
        className="remove-margin"
        value={values?.mileage}
        onChange={(value) => onChange('mileage', value)}
        placeholder={'Insira a kilometragem'}
        type="number"
        label={'Kilometragem'}
      />

      <div className="os-details-grid-date-fields">
        <LabelInput
          className="remove-margin"
          type="date"
          value={values?.delivery_date}
          onChange={(value) => onChange('delivery_date', value)}
          placeholder={'Previsão entrega'}
          label={'Previsão entrega *'}
          required
        />

        <div>
          <HourInput
            is24HoursLimited
            value={values?.delivery_hour}
            onChange={(value) => onChange('delivery_hour', value)}
            className="remove-margin"
            label="Hora entrega"
          />
        </div>

        <LabelInput
          className="remove-margin"
          type="date"
          value={values?.close_date}
          onChange={(value) => onChange('close_date', value)}
          placeholder={'Data fechamento'}
          label={'Data fechamento'}
        />

        <div>
          <HourInput
            is24HoursLimited
            value={values?.close_hour}
            onChange={(value) => onChange('close_hour', value)}
            className="remove-margin"
            label="Hora fechamento"
          />
        </div>
      </div>

      <InputFormOfPayment />

      <div className="budget-modal-main-div">
        <div className="size-dropdown">
          <div className="void-class">
            <SelectInput
              className="remove-margin"
              onChange={(event) => onChange('financial_coresponsible', event)}
              placeholder={clientLoading ? 'Carregando clientes...' : 'Escolha o Corresponsável financeiro'}
              label={'Corresponsável financeiro'}
              options={client}
              defaultValue={
                client?.find(
                  (item) =>
                    item.value === values?.financial_coresponsible?.value ||
                    item.value === values?.financial_coresponsible
                ) || null
              }
            />
          </div>
        </div>
        <DefaultButton
          className="action-button"
          label={'+'}
          onClick={() => {
            setOpen(3);
            setCurrentClientId(0);
            setClientCreationContext('financial_coresponsible');
          }}
        />

        <DefaultButton
          disabled={!values?.financial_coresponsible}
          style={{ backgroundColor: '#6694ec' }}
          className="action-button"
          label={<TbEdit style={{ width: 20, height: 20 }} />}
          onClick={() => {
            setOpen(3);
            setCurrentClientId(
              typeof values.financial_coresponsible === 'object'
                ? values.financial_coresponsible.value
                : values.financial_coresponsible
            );
          }}
        />
      </div>

      <div className="void-class">
        <SelectInput
          onChange={(value) => onChange('status', value)}
          placeholder={'Escolha o status do orçamento'}
          label={'Status'}
          defaultValue={
            oSStatusOptions.find((item) => item.id === values?.status) ||
            values?.status
          }
          value={oSStatusOptions.find((item) => item.id === values?.status)}
          options={oSStatusOptions}
          className="budget-percentage-input"
        />
      </div>

      <InputConsultant />

      <InputTypeOS />
    </div>
  );
};
